<!--查看权限的model-->
<template>
    <div class="m-portlet" v-loading="$parentInfo.dialog_TemplateUpdateEmployeePower.loading">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption" style="width: 100%">
                <div class="m-portlet__head-title" style="width: 100%">
                    <el-form style="width: 100%">
                        <div style="display: flex;width: 100%">
                            <div style="width: 10%">
                                <el-form-item>
                                    {{$parentInfo.dialog_TemplateUpdateEmployeePower.checkedSection.name}}-{{$parentInfo.dialog_TemplateUpdateEmployeePower.employee.name}}
                                </el-form-item>
                            </div>
                            <div style="width: 20%;">
                                <el-form-item label="校区选择">
                                    <el-select v-model="power_section" placeholder="请选择校区" @change="changeSection()"
                                               style="width: 80px;">
                                        <el-option
                                                v-for="item in $parentInfo.sections"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div style="width: 50%"></div>
                            <!--<div style="width: 20%">-->
                                <!--<el-button type="primary" @click="handleUpdateEmployeePower"-->
                                           <!--:loading="$parentInfo.dialog_TemplateUpdateEmployeePower.button_loading">更改权限-->
                                <!--</el-button>-->
                            <!--</div>-->
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
        <vue-scroll :ops="$ops">
            <div class="m-portlet__body" v-loading="$parentInfo.dialog_TemplateUpdateEmployeePower.loading">
                <el-tabs>
                    <el-tab-pane label="应用管理">
                        <el-collapse v-model="application">
                            <el-collapse-item title="菜单权限分配" name="application_menu">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedMenuPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(menuPower,index) in $parentInfo.allPowers.menu"
                                                :key="index">
                                            <el-checkbox :label="menuPower.id"
                                                         v-if="menuPower.dashboard=='main'">
                                                {{menuPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="学生权限分配" name="application_student">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedStudentPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(studentPower,index) in $parentInfo.allPowers.student"
                                                :key="index">
                                            <el-checkbox :label="studentPower.id">
                                                {{studentPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="课程权限分配" name="application_course">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedCoursePowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(studentPower,index) in $parentInfo.allPowers.course"
                                                :key="index">
                                            <el-checkbox :label="studentPower.id">
                                                {{studentPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="班级权限分配" name="application_class">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedClassPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(classPower,index) in $parentInfo.allPowers.class"
                                                :key="index">
                                            <el-checkbox :label="classPower.id">
                                                {{classPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="每日课表权限分配" name="application_dailySchedule">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedDayTimeTablePowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(dayTimeTablePower,index) in $parentInfo.allPowers.dayTimeTable"
                                                :key="index">
                                            <el-checkbox :label="dayTimeTablePower.id">
                                                {{dayTimeTablePower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="当前课表权限分配" name="application_schedule">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedTimeTablePowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(timeTablePower,index) in $parentInfo.allPowers.timeTable"
                                                :key="index">
                                            <el-checkbox :label="timeTablePower.id">
                                                {{timeTablePower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="月课表权限分配" name="application_monthlySchedule">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedMonthlyTimeTablePowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(monthlyTimeTablePower,index) in $parentInfo.allPowers.monthlyTimeTable"
                                                :key="index">
                                            <el-checkbox :label="monthlyTimeTablePower.id">
                                                {{monthlyTimeTablePower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="考试权限分配" name="application_Exam">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedExamPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(examPower,index) in $parentInfo.allPowers.exam"
                                                :key="index">
                                            <el-checkbox :label="examPower.id">
                                                {{examPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="回访权限分配" name="application_ReturnVisit">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedReturnVisitPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(returnVisitPower,index) in $parentInfo.allPowers.returnVisit"
                                                :key="index">
                                            <el-checkbox :label="returnVisitPower.id"
                                                         v-if="returnVisitPower.dashboard=='main'">
                                                {{returnVisitPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="推荐人管理分配" name="application_referer">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedReferrerPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(referrerPower,index) in $parentInfo.allPowers.referrer"
                                                :key="index">
                                            <el-checkbox :label="referrerPower.id">
                                                {{referrerPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="员工权限分配" name="application_employee">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedEmployeePowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(employeePower,index) in $parentInfo.allPowers.employee"
                                                :key="index">
                                            <el-checkbox :label="employeePower.id">
                                                {{employeePower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="购物车权限分配" name="application_shoppingCart">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedCartPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(cartPower,index) in $parentInfo.allPowers.cart"
                                                :key="index">
                                            <el-checkbox :label="cartPower.id">
                                                {{cartPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="教务权限分配" name="application_dean">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedSenatePowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(senatePower,index) in $parentInfo.allPowers.senate"
                                                :key="index">
                                            <el-checkbox :label="senatePower.id">
                                                {{senatePower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="签到权限分配" name="application_sign">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedSignLogPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(signLogPower,index) in $parentInfo.allPowers.signlog"
                                                :key="index">
                                            <el-checkbox :label="signLogPower.id">
                                                {{signLogPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                        </el-collapse>
                    </el-tab-pane>
                    <el-tab-pane label="数据看板">
                        <el-collapse v-model="dataInfo">
                            <el-collapse-item title="菜单权限分配" name="dataInfo_menu">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedMenuPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(menuPower,index) in $parentInfo.allPowers.menu"
                                                :key="index">
                                            <el-checkbox
                                                    :label="menuPower.id" v-if="menuPower.dashboard=='anly'">
                                                {{menuPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="合同权限分配" name="dataInfo_contract">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedInvoicePowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(invoicePower,index) in $parentInfo.allPowers.invoice"
                                                :key="index">
                                            <el-checkbox :label="invoicePower.id">
                                                {{invoicePower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="财务权限分配" name="dataInfo_financial">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedFinancialPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(financialPower,index) in $parentInfo.allPowers.financial"
                                                :key="index">
                                            <el-checkbox :label="financialPower.id">
                                                {{financialPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                        </el-collapse>
                    </el-tab-pane>
                    <el-tab-pane label="设置面板">
                        <el-collapse v-model="settingPanel">
                            <el-collapse-item title="菜单权限分配" name="settingPanel_menu">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedMenuPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(menuPower,index) in $parentInfo.allPowers.menu"
                                                :key="index">
                                            <el-checkbox :label="menuPower.id"
                                                         v-if="menuPower.dashboard=='setting'">
                                                {{menuPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="权限管理分配" name="settingPanel_power">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedAuthorityPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(authorityPower,index) in $parentInfo.allPowers.authority"
                                                :key="index">
                                            <el-checkbox :label="authorityPower.id">
                                                {{authorityPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="首页权限分配" name="settingPanel_homePage">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedHomePowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(homePower,index) in $parentInfo.allPowers.home"
                                                :key="index">
                                            <el-checkbox :label="homePower.id">
                                                {{homePower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="学期权限分配" name="settingPanel_semester">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedSemesterPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(semesterPower,index) in $parentInfo.allPowers.semester"
                                                :key="index">
                                            <el-checkbox :label="semesterPower.id">
                                                {{semesterPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="教室权限分配" name="settingPanel_classroom">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedClassroomPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(classroomPower,index) in $parentInfo.allPowers.classroom"
                                                :key="index">
                                            <el-checkbox :label="classroomPower.id">
                                                {{classroomPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                            <el-collapse-item title="班主任权限分配" name="settingPanel_headTeacher">
                                <el-checkbox-group
                                        v-model="$parentInfo.checkedHeadTeacherPowers">
                                    <el-row :gutter="20">
                                        <el-col :span="4"
                                                v-for="(headTeacherPower,index) in $parentInfo.allPowers.headTeacher"
                                                :key="index">
                                            <el-checkbox :label="headTeacherPower.id">
                                                {{headTeacherPower.name}}
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                            </el-collapse-item>
                        </el-collapse>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </vue-scroll>
    </div>
</template>

<script>
    export default {
        name: "Dialog_TemplateUpdateEmployeePower",
        data() {
            return {
                application: ['application_menu'],
                dataInfo: ['dataInfo_menu'],
                settingPanel: ['settingPanel_menu'],
                power_section: '',
                checkedAll: [],
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.dialog_TemplateUpdateEmployeePower.loading = true;
            this.power_section = 1;
            this.checkedPower();
            this.handleGetPowers();
        },
        methods: {
            changeSection() {
                this.$parentInfo.checkedStudentPowers = [];
                this.$parentInfo.checkedClassroomPowers = [];
                this.$parentInfo.checkedCoursePowers = [];
                this.$parentInfo.checkedClassPowers = [];
                this.$parentInfo.checkedHeadTeacherPowers = [];
                this.$parentInfo.checkedDayTimeTablePowers = [];
                this.$parentInfo.checkedTimeTablePowers = [];
                this.$parentInfo.checkedMonthlyTimeTablePowers = [];
                this.$parentInfo.checkedExamPowers = [];
                this.$parentInfo.checkedSemesterPowers = [];
                this.$parentInfo.checkedSenatePowers = [];
                this.$parentInfo.checkedSignLogPowers = [];
                this.$parentInfo.checkedSittingPowers = [];
                this.$parentInfo.checkedFinancialPowers = [];
                this.$parentInfo.checkedInvoicePowers = [];
                this.$parentInfo.checkedReturnVisitPowers = [];
                this.$parentInfo.checkedEmployeePowers = [];
                this.$parentInfo.checkedAuthorityPowers = [];
                this.$parentInfo.checkedReferrerPowers = [];
                this.$parentInfo.checkedHomePowers = [];
                this.$parentInfo.checkedMenuPowers = [];
                this.$parentInfo.checkedCartPowers = [];
                this.checkedPower();
            },
            handleUpdateEmployeePower() {
                this.$parentInfo.dialog_TemplateUpdateEmployeePower.button_loading = true;
                let all = this.checkedAll.concat(
                    this.$parentInfo.checkedStudentPowers,
                    this.$parentInfo.checkedClassroomPowers,
                    this.$parentInfo.checkedCoursePowers,
                    this.$parentInfo.checkedClassPowers,
                    this.$parentInfo.checkedHeadTeacherPowers,
                    this.$parentInfo.checkedDayTimeTablePowers,
                    this.$parentInfo.checkedAuthorityPowers,
                    this.$parentInfo.checkedEmployeePowers,
                    this.$parentInfo.checkedInvoicePowers,
                    this.$parentInfo.checkedReturnVisitPowers,
                    this.$parentInfo.checkedTimeTablePowers,
                    this.$parentInfo.checkedMonthlyTimeTablePowers,
                    this.$parentInfo.checkedReferrerPowers,
                    this.$parentInfo.checkedHomePowers,
                    this.$parentInfo.checkedExamPowers,
                    this.$parentInfo.checkedSemesterPowers,
                    this.$parentInfo.checkedSenatePowers,
                    this.$parentInfo.checkedSignLogPowers,
                    this.$parentInfo.checkedSittingPowers,
                    this.$parentInfo.checkedFinancialPowers,
                    this.$parentInfo.checkedMenuPowers,
                    this.$parentInfo.checkedCartPowers);
                this.$wApi.send(this.$parentInfo.path, 'update_employeePower', {
                    'all': all,
                    'id': this.$store.state.modal.data.id,
                    'power_section': this.power_section,
                });
            },
            checkedPower() {
                this.$wApi.send(this.$parentInfo.path, 'get_checkPower', {
                    'id': this.$store.state.modal.data.id,
                    'power_section': this.power_section,
                    'type': 'checkPower',
                });
            },
            handleGetPowers() {
                this.$wApi.send(this.$parentInfo.path, 'get_powers');
            },
        }
    }
</script>

<style scoped>

</style>
